import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  FlowContext: any;
  JSON: any;
  PricingFormData: any;
  URL: any;
  UUID: string;
};

export type BankSigneringApproval = {
  __typename?: 'BankSigneringApproval';
  /**
   * Latest date to sign with BankSignering
   * @deprecated No longer supported
   */
  approveByDate?: Maybe<Scalars['Date']>;
  /** Url to complete BankSignering flow, made available after signing */
  url: Scalars['String'];
};

export type CampaignDiscount = {
  __typename?: 'CampaignDiscount';
  amount: Money;
  months: Scalars['Int'];
  percentage: Scalars['Int'];
  type: CampaignDiscountType;
};

export enum CampaignDiscountType {
  FreeMonths = 'FREE_MONTHS',
  IndefinitePercentage = 'INDEFINITE_PERCENTAGE',
  MonthlyCost = 'MONTHLY_COST',
  MonthlyPercentage = 'MONTHLY_PERCENTAGE'
}

export type Cart = {
  __typename?: 'Cart';
  /** If false, campaigns cannot be added to this cart. */
  campaignsEnabled: Scalars['Boolean'];
  /** The total cost values of this cart, in terms of monthly recurring payments. */
  cost: CartCost;
  /**
   * The entries is the list of `ProductOffers` that have been placed in the cart, and thus are
   * marked for being part of a potential checkout.
   */
  entries: Array<ProductOffer>;
  id: Scalars['UUID'];
  /**
   * A list of all the redeemed campaigns.
   *
   * NOTE: We currently only support one campaign, based on platform limitations
   */
  redeemedCampaigns: Array<RedeemedCampaign>;
};

export type CartCost = {
  __typename?: 'CartCost';
  discount: Money;
  gross: Money;
  net: Money;
};

export type CartEntriesAddInput = {
  cartId: Scalars['UUID'];
  offerIds: Array<Scalars['UUID']>;
};

export type CartEntriesRemoveInput = {
  cartId: Scalars['UUID'];
  offerIds: Array<Scalars['UUID']>;
};

export type CartMutationOutput = {
  __typename?: 'CartMutationOutput';
  cart?: Maybe<Cart>;
  userError?: Maybe<UserError>;
};

export type CartRedeemCampaignInput = {
  cartId: Scalars['UUID'];
  code: Scalars['String'];
};

export type CartUnredeemCampaignInput = {
  campaignId: Scalars['String'];
  cartId: Scalars['UUID'];
};

export type Contract = {
  __typename?: 'Contract';
  /** If the insurance has been switched from a different company, this contains the relevant data */
  externalInsuranceCancellation?: Maybe<ContractExternalInsuranceCancellation>;
  id: Scalars['UUID'];
  variant: ProductVariant;
};

export type ContractBankSigneringCancellation = {
  __typename?: 'ContractBankSigneringCancellation';
  approveByDate: Scalars['Date'];
  url?: Maybe<Scalars['String']>;
};

/** Information about ongoing or completed cancellations of insurances with different companies */
export type ContractExternalInsuranceCancellation = {
  __typename?: 'ContractExternalInsuranceCancellation';
  bankSignering?: Maybe<ContractBankSigneringCancellation>;
  externalInsurer: ExternalInsurer;
  id: Scalars['UUID'];
  status: ContractExternalInsuranceCancellationStatus;
  type: ContractExternalInsuranceCancellationType;
};

export enum ContractExternalInsuranceCancellationStatus {
  /** The cancellation process is complete */
  Completed = 'COMPLETED',
  /** The cancellation process is in progress and requires no more actions from the client */
  Initiated = 'INITIATED',
  /** The contract has been created, and has the necessary information cancelling, but the cancellation process has not been initiated */
  NotInitiated = 'NOT_INITIATED'
}

export enum ContractExternalInsuranceCancellationType {
  Banksignering = 'BANKSIGNERING'
}

export enum CountryCode {
  /** Denmark */
  Dk = 'DK',
  /** Norway */
  No = 'NO',
  /** Sweden */
  Se = 'SE'
}

export type CrossSell = {
  __typename?: 'CrossSell';
  about: Scalars['String'];
  blurHash: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  productVariants: Array<ProductVariant>;
  /** A url pointing to a product page where the member can complete the purchase */
  storeUrl: Scalars['String'];
  title: Scalars['String'];
};

export enum CurrencyCode {
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK'
}

export type Entrypoint = {
  __typename?: 'Entrypoint';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type EntrypointSearchInput = {
  limit?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  type: EntrypointType;
};

export enum EntrypointType {
  Claim = 'CLAIM'
}

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export type ExternalInsuranceCancellation = {
  __typename?: 'ExternalInsuranceCancellation';
  /**
   * Properties specific to BankSignering switching
   * @deprecated No longer supported
   */
  bankSignering?: Maybe<BankSigneringApproval>;
  /** The latest date the insurance needs to be approved with banksignering */
  bankSigneringApproveByDate: Scalars['Date'];
  /** The currently set external insurer. */
  externalInsurer?: Maybe<ExternalInsurer>;
  /** Determines if and how we can help the user with cancellation. */
  option: ExternalInsuranceCancellationOption;
  /** True if cancellation has been requested. */
  requested: Scalars['Boolean'];
};

export enum ExternalInsuranceCancellationOption {
  /** We can offer BankSignering. */
  Banksignering = 'BANKSIGNERING',
  /** BankSignering is supported for the insurance but cannot be done with the given start date */
  BanksigneringInvalidRenewalDate = 'BANKSIGNERING_INVALID_RENEWAL_DATE',
  /** We can offer cancellation based on internal IEX work at Hedvig. */
  Iex = 'IEX',
  /** We cannot offer cancellation. */
  None = 'NONE'
}

export type ExternalInsurer = {
  __typename?: 'ExternalInsurer';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  insurelyId?: Maybe<Scalars['String']>;
};

export type Flow = {
  __typename?: 'Flow';
  context: Scalars['FlowContext'];
  currentStep: FlowStep;
  id: Scalars['ID'];
};

export type FlowClaimAudioContent = {
  __typename?: 'FlowClaimAudioContent';
  /**  The stored url to be used in the next step input  */
  audioUrl: Scalars['String'];
  /**  The url to get audio data from S3  */
  signedUrl: Scalars['String'];
};

export type FlowClaimAudioRecordingInput = {
  audioUrl: Scalars['String'];
};

export type FlowClaimAudioRecordingStep = FlowStep & {
  __typename?: 'FlowClaimAudioRecordingStep';
  audioContent?: Maybe<FlowClaimAudioContent>;
  id: Scalars['ID'];
  questions: Array<Scalars['String']>;
};

export type FlowClaimAutomaticAutogiroPayout = FlowClaimCheckoutMethod & {
  __typename?: 'FlowClaimAutomaticAutogiroPayout';
  amount: Money;
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type FlowClaimAutomaticAutogiroPayoutInput = {
  amount: Scalars['Float'];
};

export type FlowClaimCheckoutMethod = {
  id: Scalars['ID'];
};

export type FlowClaimDateOfOccurrenceInput = {
  dateOfOccurrence?: InputMaybe<Scalars['Date']>;
};

export type FlowClaimDateOfOccurrencePlusLocationInput = {
  dateOfOccurrence?: InputMaybe<Scalars['Date']>;
  location?: InputMaybe<Scalars['ID']>;
};

export type FlowClaimDateOfOccurrencePlusLocationStep = FlowStep & {
  __typename?: 'FlowClaimDateOfOccurrencePlusLocationStep';
  dateOfOccurrenceStep: FlowClaimDateOfOccurrenceStep;
  id: Scalars['ID'];
  locationStep: FlowClaimLocationStep;
};

export type FlowClaimDateOfOccurrenceStep = FlowStep & {
  __typename?: 'FlowClaimDateOfOccurrenceStep';
  dateOfOccurrence?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  maxDate: Scalars['Date'];
};

export type FlowClaimFailedStep = FlowStep & {
  __typename?: 'FlowClaimFailedStep';
  id: Scalars['ID'];
};

export type FlowClaimItemBrandInput = {
  itemBrandId: Scalars['ID'];
  itemTypeId: Scalars['ID'];
};

export type FlowClaimItemBrandOption = {
  __typename?: 'FlowClaimItemBrandOption';
  displayName: Scalars['String'];
  itemBrandId: Scalars['ID'];
  itemTypeId: Scalars['ID'];
};

export type FlowClaimItemModelInput = {
  itemModelId: Scalars['ID'];
};

export type FlowClaimItemModelOption = {
  __typename?: 'FlowClaimItemModelOption';
  displayName: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  itemBrandId: Scalars['ID'];
  itemModelId: Scalars['ID'];
  itemTypeId: Scalars['ID'];
};

export type FlowClaimItemProblemOption = {
  __typename?: 'FlowClaimItemProblemOption';
  displayName: Scalars['String'];
  itemProblemId: Scalars['ID'];
};

export type FlowClaimLocationInput = {
  location?: InputMaybe<Scalars['ID']>;
};

export type FlowClaimLocationOption = {
  __typename?: 'FlowClaimLocationOption';
  displayName: Scalars['String'];
  value: Scalars['ID'];
};

export type FlowClaimLocationStep = FlowStep & {
  __typename?: 'FlowClaimLocationStep';
  id: Scalars['ID'];
  location?: Maybe<Scalars['ID']>;
  options: Array<FlowClaimLocationOption>;
};

export type FlowClaimPhoneNumberInput = {
  phoneNumber: Scalars['String'];
};

export type FlowClaimPhoneNumberStep = FlowStep & {
  __typename?: 'FlowClaimPhoneNumberStep';
  id: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type FlowClaimSingleItemCheckoutInput = {
  automaticAutogiro?: InputMaybe<FlowClaimAutomaticAutogiroPayoutInput>;
};

export type FlowClaimSingleItemCheckoutStep = FlowStep & {
  __typename?: 'FlowClaimSingleItemCheckoutStep';
  availableCheckoutMethods: Array<FlowClaimCheckoutMethod>;
  deductible: Money;
  depreciation: Money;
  id: Scalars['ID'];
  payoutAmount: Money;
  price: Money;
};

export type FlowClaimSingleItemInput = {
  customName?: InputMaybe<Scalars['String']>;
  /**  Can only send one of FlowClaimItemBrandInput and FlowClaimItemModelInput */
  itemBrandInput?: InputMaybe<FlowClaimItemBrandInput>;
  /**  Can only send one of FlowClaimItemBrandInput and FlowClaimItemModelInput */
  itemModelInput?: InputMaybe<FlowClaimItemModelInput>;
  itemProblemIds?: InputMaybe<Array<Scalars['ID']>>;
  purchaseDate?: InputMaybe<Scalars['Date']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
};

export type FlowClaimSingleItemStep = FlowStep & {
  __typename?: 'FlowClaimSingleItemStep';
  /**  Do not render if null */
  availableItemBrands?: Maybe<Array<FlowClaimItemBrandOption>>;
  /**  Do not render if null */
  availableItemModels?: Maybe<Array<FlowClaimItemModelOption>>;
  /**  Do not render if null */
  availableItemProblems?: Maybe<Array<FlowClaimItemProblemOption>>;
  customName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  preferredCurrency: CurrencyCode;
  purchaseDate?: Maybe<Scalars['Date']>;
  purchasePrice?: Maybe<Money>;
  selectedItemBrand?: Maybe<Scalars['ID']>;
  selectedItemModel?: Maybe<Scalars['ID']>;
  selectedItemProblems: Array<Scalars['ID']>;
};

export type FlowClaimStartInput = {
  entrypointId?: InputMaybe<Scalars['ID']>;
};

export type FlowClaimSuccessStep = FlowStep & {
  __typename?: 'FlowClaimSuccessStep';
  id: Scalars['ID'];
};

export type FlowClaimSummaryInput = {
  customName?: InputMaybe<Scalars['String']>;
  dateOfOccurrence?: InputMaybe<Scalars['Date']>;
  /**  Can only send one of FlowClaimItemBrandInput and FlowClaimItemModelInput */
  itemBrandInput?: InputMaybe<FlowClaimItemBrandInput>;
  /**  Can only send one of FlowClaimItemBrandInput and FlowClaimItemModelInput */
  itemModelInput?: InputMaybe<FlowClaimItemModelInput>;
  itemProblemIds?: InputMaybe<Array<Scalars['ID']>>;
  location?: InputMaybe<Scalars['ID']>;
  purchaseDate?: InputMaybe<Scalars['Date']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
};

export type FlowClaimSummaryStep = FlowStep & {
  __typename?: 'FlowClaimSummaryStep';
  dateOfOccurrenceStep: FlowClaimDateOfOccurrenceStep;
  id: Scalars['ID'];
  locationStep: FlowClaimLocationStep;
  singleItemStep?: Maybe<FlowClaimSingleItemStep>;
  title: Scalars['String'];
};

export type FlowStep = {
  id: Scalars['ID'];
};

export type FlowTerminationDateInput = {
  terminationDate: Scalars['Date'];
};

export type FlowTerminationDateStep = FlowStep & {
  __typename?: 'FlowTerminationDateStep';
  id: Scalars['ID'];
  maxDate: Scalars['Date'];
  minDate: Scalars['Date'];
};

export type FlowTerminationDeletionInput = {
  /** This has no significance and is ignored by the backend. It exists to satisfy some codegen limitations */
  confirmed: Scalars['Boolean'];
};

export type FlowTerminationDeletionStep = FlowStep & {
  __typename?: 'FlowTerminationDeletionStep';
  disclaimer: Scalars['String'];
  id: Scalars['ID'];
};

export type FlowTerminationFailedStep = FlowStep & {
  __typename?: 'FlowTerminationFailedStep';
  id: Scalars['ID'];
};

export type FlowTerminationStartInput = {
  contractId: Scalars['ID'];
};

export type FlowTerminationSuccessStep = FlowStep & {
  __typename?: 'FlowTerminationSuccessStep';
  id: Scalars['ID'];
  surveyUrl: Scalars['String'];
  terminationDate?: Maybe<Scalars['Date']>;
};

export enum HedvigColor {
  Black = 'Black',
  BlackPurple = 'BlackPurple',
  DarkGray = 'DarkGray',
  DarkPurple = 'DarkPurple',
  LightGray = 'LightGray',
  OffBlack = 'OffBlack',
  OffWhite = 'OffWhite',
  Pink = 'Pink',
  Purple = 'Purple',
  Turquoise = 'Turquoise',
  White = 'White',
  Yellow = 'Yellow'
}

export type HelloFromOdyssey = {
  __typename?: 'HelloFromOdyssey';
  value: Scalars['String'];
};

export type Icon = {
  __typename?: 'Icon';
  variants: IconVariants;
};

export type IconVariant = {
  __typename?: 'IconVariant';
  pdfUrl: Scalars['String'];
  svgUrl: Scalars['String'];
};

export type IconVariants = {
  __typename?: 'IconVariants';
  dark: IconVariant;
  light: IconVariant;
};

export type InsurableLimit = {
  __typename?: 'InsurableLimit';
  description: Scalars['String'];
  label: Scalars['String'];
  limit: Scalars['String'];
  type: InsurableLimitType;
};

export enum InsurableLimitType {
  Bike = 'BIKE',
  Deductible = 'DEDUCTIBLE',
  DeductibleAllRisk = 'DEDUCTIBLE_ALL_RISK',
  DeductibleNatureDamage = 'DEDUCTIBLE_NATURE_DAMAGE',
  DentalTreatment = 'DENTAL_TREATMENT',
  GoodsFamily = 'GOODS_FAMILY',
  GoodsIndividual = 'GOODS_INDIVIDUAL',
  InsuredAmount = 'INSURED_AMOUNT',
  LostLuggage = 'LOST_LUGGAGE',
  MedicalExpenses = 'MEDICAL_EXPENSES',
  PermanentInjury = 'PERMANENT_INJURY',
  TravelCancellation = 'TRAVEL_CANCELLATION',
  TravelDays = 'TRAVEL_DAYS',
  TravelDelayedLuggage = 'TRAVEL_DELAYED_LUGGAGE',
  TravelDelayedOnTrip = 'TRAVEL_DELAYED_ON_TRIP',
  TravelIllnessInjuryTransportationHome = 'TRAVEL_ILLNESS_INJURY_TRANSPORTATION_HOME',
  Treatment = 'TREATMENT'
}

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  displayName: Scalars['String'];
  type: InsuranceDocumentType;
  url: Scalars['String'];
};

export enum InsuranceDocumentType {
  GeneralTerms = 'GENERAL_TERMS',
  PreSaleInfo = 'PRE_SALE_INFO',
  PreSaleInfoEuStandard = 'PRE_SALE_INFO_EU_STANDARD',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type InsuranceFaq = {
  __typename?: 'InsuranceFaq';
  body?: Maybe<Scalars['String']>;
  headline: Scalars['String'];
};

export type InsuranceHighlight = {
  __typename?: 'InsuranceHighlight';
  description: Scalars['String'];
  title: Scalars['String'];
};

export type InsuranceProvider = {
  __typename?: 'InsuranceProvider';
  externalCollectionId?: Maybe<Scalars['String']>;
  hasExternalCapabilities: Scalars['Boolean'];
  id: Scalars['String'];
  logo: Icon;
  name: Scalars['String'];
  switchable: Scalars['Boolean'];
};

export type InsurelyInitiateIframeDataCollectionInput = {
  collectionId: Scalars['String'];
  partner?: InputMaybe<Scalars['String']>;
};

export type InsurelyInitiateIframeDataCollectionOutput = {
  __typename?: 'InsurelyInitiateIframeDataCollectionOutput';
  dataCollectionId: Scalars['ID'];
};

export enum Locale {
  DaDk = 'da_DK',
  EnDk = 'en_DK',
  EnNo = 'en_NO',
  EnSe = 'en_SE',
  NbNo = 'nb_NO',
  SvSe = 'sv_SE'
}

export type Member = {
  __typename?: 'Member';
  crossSells: Array<CrossSell>;
  firstName: Scalars['String'];
  hasActivePaymentConnection: Scalars['Boolean'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type MonetaryAmountV2 = {
  __typename?: 'MonetaryAmountV2';
  amount: Scalars['String'];
  currency: Scalars['String'];
};

/** A monetary value with currency. */
export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  /** Currency of the money (ISO 4217). */
  currencyCode: CurrencyCode;
};

export type MoveAddress = {
  __typename?: 'MoveAddress';
  apartmentNumber?: Maybe<Scalars['String']>;
  bbrId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export enum MoveApartmentSubType {
  Own = 'OWN',
  Rent = 'RENT'
}

export type MoveIntent = {
  __typename?: 'MoveIntent';
  currentHomeAddresses: Array<MoveAddress>;
  id: Scalars['ID'];
  maxMovingDate: Scalars['Date'];
  minMovingDate: Scalars['Date'];
  /**  On current contract  */
  numberCoInsured: Scalars['Int'];
  /**  Will only be present after moveIntentRequest  */
  quotes: Array<MoveQuote>;
};

export type MoveIntentCreateInput = {
  toType: MoveToType;
};

/**  Only one field can be present  */
export type MoveIntentMutationOutput = {
  __typename?: 'MoveIntentMutationOutput';
  /**  Success case  */
  moveIntent?: Maybe<MoveIntent>;
  /**  Fail case  */
  userError?: Maybe<UserError>;
};

export type MoveIntentRequestInput = {
  apartment?: InputMaybe<MoveToApartmentInput>;
  /**  This is the ID you get in MoveIntent:currentHomeAddresses  */
  moveFromAddressId: Scalars['ID'];
  moveToAddress: MoveToAddressInput;
  /**  Should be inside range given on MoveIntent  */
  movingDate: Scalars['Date'];
  numberCoInsured: Scalars['Int'];
  squareMeters: Scalars['Int'];
};

export type MoveQuote = {
  __typename?: 'MoveQuote';
  address: MoveAddress;
  numberCoInsured: Scalars['Int'];
  premium: Money;
  startDate: Scalars['Date'];
  termsVersion: TermsVersion;
};

export type MoveToAddressInput = {
  /**  Only applicable for Denmark  */
  apartmentNumber?: InputMaybe<Scalars['String']>;
  /**  Only applicable for Denmark  */
  bbrId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  /**  Only applicable for Denmark  */
  floor?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  /**  For development: send 'error' to get UserError  */
  street: Scalars['String'];
};

export type MoveToApartmentInput = {
  isStudent: Scalars['Boolean'];
  subType: MoveApartmentSubType;
};

export enum MoveToType {
  Apartment = 'APARTMENT',
  House = 'HOUSE'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Initiates the BankSignering and returns the url to complete the BankSignering flow. */
  bankSigneringApprovalCreate: BankSigneringApproval;
  /** Add a list of `ProductOffer`s by their ID to the cart. */
  cartEntriesAdd: CartMutationOutput;
  /** Remove a list of `ProductOffer`s by their ID from the cart. */
  cartEntriesRemove: CartMutationOutput;
  /** Try to attach a campaign with the given code to the cart. Returns a `userError` value if the code is invalid. */
  cartRedeemCampaign: CartMutationOutput;
  /** Remove the given campaign from the cart. */
  cartUnredeemCampaign: Cart;
  contractBankSigneringCancellationInitiate: Contract;
  flowClaimAudioRecordingNext: Flow;
  flowClaimDateOfOccurrenceNext: Flow;
  flowClaimDateOfOccurrencePlusLocationNext: Flow;
  flowClaimLocationNext: Flow;
  flowClaimPhoneNumberNext: Flow;
  flowClaimSingleItemCheckoutNext: Flow;
  flowClaimSingleItemNext: Flow;
  flowClaimStart: Flow;
  flowClaimSummaryNext: Flow;
  flowTerminationDateNext: Flow;
  flowTerminationDeletionNext: Flow;
  flowTerminationStart: Flow;
  helloUnderwriter: Scalars['String'];
  /**
   * This is a re-implementation of the existing Mutation.externalInsurnaceProvider.initiateIframeDataCollection
   * mutation, as the old one uses an unsupported resolver design (nested/namespaced mutations).
   */
  insurelyInitiateIframeDataCollection: InsurelyInitiateIframeDataCollectionOutput;
  /**  Get intentId from MoveIntent:id  */
  moveIntentCommit: MoveIntentMutationOutput;
  /**  Initiate a Move intent  */
  moveIntentCreate: MoveIntentMutationOutput;
  /**  Get intentId from MoveIntent:id  */
  moveIntentRequest: MoveIntentMutationOutput;
  partnerWidgetInit: ShopSession;
  /**
   * Confirm this PriceIntent, which will use the current data (and likely `ShopSession.customer`) to generate
   * `ProductOffers` that can be added to the cart.
   */
  priceIntentConfirm: PriceIntentMutationOutput;
  /**
   * Create a `PriceIntent`.
   *
   * The `input.productName` has to be the name of a product among the ones listed at `Query.availableProducts`. The
   * choice of product also affects which data will be needed for the intent to be confirmed and to produce offers.
   */
  priceIntentCreate: PriceIntent;
  /**
   * Update the raw insurance-related data for this `PriceIntent`. This data is mostly related to the insured object
   * itself, and not the "holder" of the insurance.
   */
  priceIntentDataUpdate: PriceIntentMutationOutput;
  /**
   * Set the external insurer ID (value of `ExternalInsurer.id`) for this price intent.
   *
   * Mostly used for helping the user with cancellation/switching.
   */
  priceIntentExternalInsurerUpdate: PriceIntentMutationOutput;
  /** Associate a specific Insurely `dataCollectionId` from lookup-service with this PriceIntent. */
  priceIntentInsurelyUpdate: PriceIntentMutationOutput;
  /**
   * Update the 'cancellation requested' value of the given offers. True means that the user wants us
   * to help them with switching/cancellation, and false means that they don't.
   */
  productOffersCancellationRequestedUpdate: ProductOffersMutationOutput;
  /**
   * Change the start date of the given `ProductOffer`s by their ID.
   *
   * This is used because it's common to want to change the start date AFTER getting the offer.
   */
  productOffersStartDateUpdate: ProductOffersMutationOutput;
  sayHelloFromWorld: HelloFromOdyssey;
  /**
   * Attempt to move the `ShopSessionAuthenticationStatus` of this session to `AUTHENTICATED`. Requires
   * a Member-scoped access_token.
   */
  shopSessionAuthenticate: ShopSession;
  /**
   * Create a `ShopSession`. The `input.countryCode` value will have implications on the behaviour of the session
   * in terms of what products can be bought using it and underlying integrations.
   */
  shopSessionCreate: ShopSession;
  /**
   * Update the customer of the shop session. Only non-null fields will be changed.
   * Can trigger automatic lookup of other information.
   *
   * The session can be placed in a "point of no return" state where it is no longer legal to update the customer,
   * which will generate errors.
   */
  shopSessionCustomerUpdate: ShopSessionMutationOutput;
  /**
   * Begin signing the session, with the ultimate goal of creating insurances in our system, and possibly
   * also creating a new Member.
   *
   * Signing is an asynchronous process, where the client must poll using `Query.shopSessionSigning` and follow
   * the state changes. Some signing requires external work for the user, such as Swedish BankID signing.
   */
  shopSessionStartSign: ShopSessionSigningMutationOutput;
};


export type MutationBankSigneringApprovalCreateArgs = {
  productOfferId: Scalars['UUID'];
};


export type MutationCartEntriesAddArgs = {
  input: CartEntriesAddInput;
};


export type MutationCartEntriesRemoveArgs = {
  input: CartEntriesRemoveInput;
};


export type MutationCartRedeemCampaignArgs = {
  input: CartRedeemCampaignInput;
};


export type MutationCartUnredeemCampaignArgs = {
  input: CartUnredeemCampaignInput;
};


export type MutationContractBankSigneringCancellationInitiateArgs = {
  contractId: Scalars['UUID'];
};


export type MutationFlowClaimAudioRecordingNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimAudioRecordingInput;
};


export type MutationFlowClaimDateOfOccurrenceNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimDateOfOccurrenceInput;
};


export type MutationFlowClaimDateOfOccurrencePlusLocationNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimDateOfOccurrencePlusLocationInput;
};


export type MutationFlowClaimLocationNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimLocationInput;
};


export type MutationFlowClaimPhoneNumberNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimPhoneNumberInput;
};


export type MutationFlowClaimSingleItemCheckoutNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimSingleItemCheckoutInput;
};


export type MutationFlowClaimSingleItemNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimSingleItemInput;
};


export type MutationFlowClaimStartArgs = {
  context?: InputMaybe<Scalars['FlowContext']>;
  input: FlowClaimStartInput;
};


export type MutationFlowClaimSummaryNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowClaimSummaryInput;
};


export type MutationFlowTerminationDateNextArgs = {
  context: Scalars['FlowContext'];
  input: FlowTerminationDateInput;
};


export type MutationFlowTerminationDeletionNextArgs = {
  context: Scalars['FlowContext'];
  input?: InputMaybe<FlowTerminationDeletionInput>;
};


export type MutationFlowTerminationStartArgs = {
  context?: InputMaybe<Scalars['FlowContext']>;
  input: FlowTerminationStartInput;
};


export type MutationInsurelyInitiateIframeDataCollectionArgs = {
  input: InsurelyInitiateIframeDataCollectionInput;
};


export type MutationMoveIntentCommitArgs = {
  intentId: Scalars['ID'];
};


export type MutationMoveIntentCreateArgs = {
  input: MoveIntentCreateInput;
};


export type MutationMoveIntentRequestArgs = {
  input: MoveIntentRequestInput;
  intentId: Scalars['ID'];
};


export type MutationPartnerWidgetInitArgs = {
  input: PartnerWidgetInitInput;
};


export type MutationPriceIntentConfirmArgs = {
  priceIntentId: Scalars['UUID'];
};


export type MutationPriceIntentCreateArgs = {
  input: PriceIntentCreateInput;
};


export type MutationPriceIntentDataUpdateArgs = {
  data: Scalars['PricingFormData'];
  priceIntentId: Scalars['UUID'];
};


export type MutationPriceIntentExternalInsurerUpdateArgs = {
  externalInsurerId?: InputMaybe<Scalars['ID']>;
  priceIntentId: Scalars['UUID'];
};


export type MutationPriceIntentInsurelyUpdateArgs = {
  dataCollectionId: Scalars['String'];
  priceIntentId: Scalars['UUID'];
};


export type MutationProductOffersCancellationRequestedUpdateArgs = {
  productOfferIds: Array<Scalars['UUID']>;
  requested: Scalars['Boolean'];
};


export type MutationProductOffersStartDateUpdateArgs = {
  productOfferIds: Array<Scalars['UUID']>;
  startDate: Scalars['Date'];
};


export type MutationSayHelloFromWorldArgs = {
  text: Scalars['String'];
};


export type MutationShopSessionAuthenticateArgs = {
  id: Scalars['UUID'];
};


export type MutationShopSessionCreateArgs = {
  input: ShopSessionCreateInput;
};


export type MutationShopSessionCustomerUpdateArgs = {
  input: ShopSessionCustomerUpdateInput;
};


export type MutationShopSessionStartSignArgs = {
  shopSessionId: Scalars['UUID'];
};

export type News = {
  __typename?: 'News';
  illustration: Icon;
  paragraph: Scalars['String'];
  title: Scalars['String'];
};

export type PartnerWidgetData = {
  __typename?: 'PartnerWidgetData';
  externalRequestId: Scalars['String'];
  trialInfo?: Maybe<PartnerWidgetTrialInfo>;
};

export type PartnerWidgetInitInput = {
  countryCode: CountryCode;
  externalMemberId?: InputMaybe<Scalars['String']>;
  externalRequestId?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['UUID'];
};

export type PartnerWidgetTrialInfo = {
  __typename?: 'PartnerWidgetTrialInfo';
  birthDate: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  firstName?: Maybe<Scalars['String']>;
  insuranceData: Scalars['JSON'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
};

export type Peril = {
  __typename?: 'Peril';
  colorCode?: Maybe<Scalars['String']>;
  covered: Array<Scalars['String']>;
  description: Scalars['String'];
  exceptions: Array<Scalars['String']>;
  id: Scalars['ID'];
  info: Scalars['String'];
  shortDescription: Scalars['String'];
  title: Scalars['String'];
};

export type PerilV2 = {
  __typename?: 'PerilV2';
  covered: Array<Scalars['String']>;
  description: Scalars['String'];
  exceptions: Array<Scalars['String']>;
  icon: Icon;
  iconName: Scalars['String'];
  info: Scalars['String'];
  shortDescription: Scalars['String'];
  title: Scalars['String'];
};

export enum Platform {
  Android = 'Android',
  IOs = 'iOS'
}

export type PriceIntent = {
  __typename?: 'PriceIntent';
  /** Submitted user form data. */
  data: Scalars['PricingFormData'];
  /** The person's current insurance company */
  externalInsurer?: Maybe<ExternalInsurer>;
  /** The id of the price intent. */
  id: Scalars['UUID'];
  insurelyClientId?: Maybe<Scalars['String']>;
  /** The resulting product offers generated by inputting data and confirming the intent. */
  offers: Array<ProductOffer>;
  /** The product associated to this price intent */
  product: Product;
  /** Data submitted in other places or inferred from other data points */
  suggestedData: Scalars['PricingFormData'];
};

export enum PriceIntentAnimal {
  Cat = 'CAT',
  Dog = 'DOG'
}

export type PriceIntentAnimalBreed = {
  __typename?: 'PriceIntentAnimalBreed';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isMixedBreed: Scalars['Boolean'];
};

export type PriceIntentCreateInput = {
  /** The human readable, logical name that identifies the product. I.e. `SE_APARTMENT_BRF` or similar. */
  productName: Scalars['String'];
  shopSessionId: Scalars['UUID'];
};

export type PriceIntentMutationOutput = {
  __typename?: 'PriceIntentMutationOutput';
  priceIntent?: Maybe<PriceIntent>;
  userError?: Maybe<UserError>;
};

/**
 * A `Product` is a data type representing a group of insurances that share certain characteristics and are packaged
 * together from the user perspective as a single entry on the store.
 *
 * The user will view it and think of it as a specific insurance, but under the hood it can be ultimately translated
 * into different `ProductVariant`s and ultimately different specific insurances depending on the data sent in
 * by the user in the `PriceIntent`.
 */
export type Product = {
  __typename?: 'Product';
  developerValues: ProductDeveloperValues;
  /** Localized name of the product in long form. */
  displayNameFull: Scalars['String'];
  /** Localized name of the product in short form. */
  displayNameShort: Scalars['String'];
  /** A list of the external insurers valid for this specific product. */
  externalInsurers: Array<ExternalInsurer>;
  /** The featured image asset associated with this product. */
  featuredImage?: Maybe<StoryblokImageAsset>;
  id: Scalars['ID'];
  /** A value that can be used to set up an Insurely iframe for data collection. */
  insurelyClientId?: Maybe<Scalars['String']>;
  /** A unique, human readable, identifier of the product */
  name: Scalars['String'];
  /** Relative URL to the detail page of this product. */
  pageLink: Scalars['String'];
  /** The pillow image asset associated with this product. */
  pillowImage: StoryblokImageAsset;
  /** Localized tagline of the product. */
  tagline: Scalars['String'];
  /** Return all the possible `ProductVariants` that can come out of this Product */
  variants: Array<ProductVariant>;
};

export type ProductDeveloperValues = {
  __typename?: 'ProductDeveloperValues';
  exampleFormData: Scalars['PricingFormData'];
  fields: Scalars['JSON'];
};

export type ProductOffer = {
  __typename?: 'ProductOffer';
  /** Values related to cancellation/switching of their existing other insurance. */
  cancellation: ExternalInsuranceCancellation;
  /** The deductible description of this offer, if there is one. */
  deductible?: Maybe<ProductOfferDeductible>;
  /** The id of this item, which can be used to add to cart. */
  id: Scalars['UUID'];
  /** The cost of this offer. */
  price: Money;
  /** The form data used to generate the offer */
  priceIntentData: Scalars['PricingFormData'];
  /** Information about a price match with an external insurance */
  priceMatch?: Maybe<ProductOfferPriceMatch>;
  /** The start date of the insurance */
  startDate?: Maybe<Scalars['Date']>;
  /** The variant of product that this offer resembles. */
  variant: ProductVariant;
};

export type ProductOfferDeductible = {
  __typename?: 'ProductOfferDeductible';
  displayName: Scalars['String'];
  tagline: Scalars['String'];
};

export type ProductOfferPriceMatch = {
  __typename?: 'ProductOfferPriceMatch';
  externalInsurer: ExternalInsurer;
  externalPrice: Money;
  priceReduction: Money;
};

export type ProductOffersMutationOutput = {
  __typename?: 'ProductOffersMutationOutput';
  productOffers: Array<ProductOffer>;
  userError?: Maybe<UserError>;
};

/**
 * A recommendation is a suggestion by the platform for a specific product that might be of interest
 * to the user based on input so far.
 *
 * Some recommendations even have a pre-packaged `ProductOffer` that can be added to the cart immediately,
 * if the user has input enough information to generate it.
 */
export type ProductRecommendation = {
  __typename?: 'ProductRecommendation';
  offer?: Maybe<ProductOffer>;
  product: Product;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  displayName: Scalars['String'];
  documents: Array<InsuranceDocument>;
  faq: Array<InsuranceFaq>;
  highlights: Array<InsuranceHighlight>;
  insurableLimits: Array<InsurableLimit>;
  perils: Array<Peril>;
  /**
   * The Product that this variant belongs to.
   *
   * For now, all product variants can be uniquely traced back to a single product.
   */
  product: Product;
  /** The typeOfContract is virtually the ID of the ProductVariant */
  typeOfContract: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  availableProducts: Array<Product>;
  currentMember: Member;
  entrypointSearch: Array<Entrypoint>;
  helloFromOdyssey: HelloFromOdyssey;
  insuranceProviders: Array<InsuranceProvider>;
  news: Array<News>;
  perils: Array<PerilV2>;
  priceIntent: PriceIntent;
  priceIntentAvailableBreeds: Array<PriceIntentAnimalBreed>;
  product?: Maybe<Product>;
  referralTerms: ReferralTerm;
  shopSession: ShopSession;
  shopSessionSigning: ShopSessionSigning;
  welcome: Array<Welcome>;
};


export type QueryEntrypointSearchArgs = {
  input?: InputMaybe<EntrypointSearchInput>;
};


export type QueryInsuranceProvidersArgs = {
  locale: Locale;
};


export type QueryNewsArgs = {
  locale: Locale;
  platform: Platform;
  sinceVersion: Scalars['String'];
};


export type QueryPerilsArgs = {
  contractType: TypeOfContract;
  locale: Locale;
};


export type QueryPriceIntentArgs = {
  id: Scalars['UUID'];
};


export type QueryPriceIntentAvailableBreedsArgs = {
  animal: PriceIntentAnimal;
};


export type QueryProductArgs = {
  productName: Scalars['String'];
};


export type QueryReferralTermsArgs = {
  locale: Locale;
};


export type QueryShopSessionArgs = {
  id: Scalars['UUID'];
};


export type QueryShopSessionSigningArgs = {
  id: Scalars['UUID'];
};


export type QueryWelcomeArgs = {
  locale: Locale;
  platform: Platform;
};

/** A campaign attached to a `Cart` which carries its related discount. */
export type RedeemedCampaign = {
  __typename?: 'RedeemedCampaign';
  code: Scalars['String'];
  discount: CampaignDiscount;
  id: Scalars['ID'];
};

export type ReferralTerm = {
  __typename?: 'ReferralTerm';
  url: Scalars['URL'];
};

export type ShopSession = {
  __typename?: 'ShopSession';
  /** The Cart value of this shop session, carrying offers currently awaiting checkout. */
  cart: Cart;
  /** The country this session was created with. */
  countryCode: CountryCode;
  /** Creation timestamp. */
  created: Scalars['DateTime'];
  /** The currency associated with the country of the session. */
  currencyCode: CurrencyCode;
  /**
   * The customer value of the session. Can be updated through a mutation.
   *
   * The initial value is:
   * - null if the session was created without authentication
   * - non-null if the session was created as a logged in member
   */
  customer?: Maybe<ShopSessionCustomer>;
  id: Scalars['UUID'];
  /** The outcome of a signed shop-session. Requires authentication. */
  outcome?: Maybe<ShopSessionOutcome>;
  partnerName?: Maybe<Scalars['String']>;
  partnerWidgetData?: Maybe<PartnerWidgetData>;
  /** The full list of created price intents in this session. */
  priceIntents: Array<PriceIntent>;
  /** Product recommendations for the member (this field is authenticated). */
  recommendations: Array<ProductRecommendation>;
};

export enum ShopSessionAuthenticationStatus {
  /**
   * The session is authenticated.
   *
   * This usually means that no specific steps need to be taken in order to complete (sign) the session.
   */
  Authenticated = 'AUTHENTICATED',
  /**
   * Authentication required - signing in this state is not possible.
   *
   * This usually means that the data given to the `ShopSession`, such as `customer` conflicts in some way with data
   * on our platform, and that the user needs to authenticate to proceed. This means logging in and ultimately calling
   * `Mutation.shopSessionAuthenticate`.
   */
  AuthenticationRequired = 'AUTHENTICATION_REQUIRED',
  /**
   * Authentication not required.
   *
   * This could either indicate that the `ShopSession` has very little data, or that the input `ShopSession.customer`
   * value does not in any way conflict with existing data on the platform.
   */
  None = 'NONE'
}

export type ShopSessionCreateInput = {
  attributedTo?: InputMaybe<Scalars['String']>;
  countryCode: CountryCode;
  initiatedFrom?: InputMaybe<Scalars['String']>;
};

/**
 * The customer is a type containing information about the user interacting with the Store.
 *
 * This can either contain data actively provided through the customer update mutation, but also data automatically
 * looked up based on things like ssn.
 *
 * This data will ultimately be translated into `holder` information of the underlying insurance.
 */
export type ShopSessionCustomer = {
  __typename?: 'ShopSessionCustomer';
  /**
   * This field reflects whether the provided customer information might require the user to log in before
   * proceeding with the shopping experience.
   *
   * This could be to the information somehow overlapping with existing data in our system.
   */
  authenticationStatus: ShopSessionAuthenticationStatus;
  /** The email of the customer. Can be used for CRM purposes. */
  email?: Maybe<Scalars['String']>;
  /** First name(s) of the customer. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name(s) of the customer. */
  lastName?: Maybe<Scalars['String']>;
  /** The personal number of the customer. Can be used for looking up other information. */
  ssn?: Maybe<Scalars['String']>;
};

export type ShopSessionCustomerUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  shopSessionId: Scalars['UUID'];
  ssn?: InputMaybe<Scalars['String']>;
};

export type ShopSessionMutationOutput = {
  __typename?: 'ShopSessionMutationOutput';
  shopSession?: Maybe<ShopSession>;
  userError?: Maybe<UserError>;
};

/**
 * Contains relevant post-sign objects of the shop-session. After a shop session is completed, this object is added to
 * the shop-session and can be used to perform necessary post-sign actions, such as external insurance cancellation.
 */
export type ShopSessionOutcome = {
  __typename?: 'ShopSessionOutcome';
  createdContracts: Array<Contract>;
  id: Scalars['UUID'];
};

export type ShopSessionSigning = {
  __typename?: 'ShopSessionSigning';
  /** A value that will be present if status is SIGNED. */
  completion?: Maybe<ShopSessionSigningCompletion>;
  id: Scalars['UUID'];
  /** The status of this signing. */
  status: ShopSessionSigningStatus;
};

export type ShopSessionSigningCompletion = {
  __typename?: 'ShopSessionSigningCompletion';
  /**
   * A value that can be used to create an accessToken/refreshToken pair from the auth service. This is used
   * to let the user become a fully logged in member automatically after signing their insurance.
   */
  authorizationCode: Scalars['String'];
};

export type ShopSessionSigningMutationOutput = {
  __typename?: 'ShopSessionSigningMutationOutput';
  signing?: Maybe<ShopSessionSigning>;
  userError?: Maybe<UserError>;
};

export enum ShopSessionSigningStatus {
  /**
   * This state indicates that the signing is accepted, but is actively being rolled out through the system.
   * The front-end can use this value to display progress feedback to the user if wanted.
   */
  Creating = 'CREATING',
  /** The signing failed for some reason. Could be that it was cancelled by the user or something else. */
  Failed = 'FAILED',
  /** Signing still in-process, and is awaiting action from the user, such as using an external BankID service. */
  Pending = 'PENDING',
  /** This means the signing has completed successfully. */
  Signed = 'SIGNED'
}

export type StoryblokImageAsset = {
  __typename?: 'StoryblokImageAsset';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  src: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  helloFromOdysseySubscription: HelloFromOdyssey;
};

export type TermsVersion = {
  __typename?: 'TermsVersion';
  id: Scalars['ID'];
};

export enum TypeOfContract {
  DkAccident = 'DK_ACCIDENT',
  DkAccidentStudent = 'DK_ACCIDENT_STUDENT',
  DkHomeContentOwn = 'DK_HOME_CONTENT_OWN',
  DkHomeContentRent = 'DK_HOME_CONTENT_RENT',
  DkHomeContentStudentOwn = 'DK_HOME_CONTENT_STUDENT_OWN',
  DkHomeContentStudentRent = 'DK_HOME_CONTENT_STUDENT_RENT',
  DkTravel = 'DK_TRAVEL',
  DkTravelStudent = 'DK_TRAVEL_STUDENT',
  NoHomeContentOwn = 'NO_HOME_CONTENT_OWN',
  NoHomeContentRent = 'NO_HOME_CONTENT_RENT',
  NoHomeContentYouthOwn = 'NO_HOME_CONTENT_YOUTH_OWN',
  NoHomeContentYouthRent = 'NO_HOME_CONTENT_YOUTH_RENT',
  NoTravel = 'NO_TRAVEL',
  NoTravelYouth = 'NO_TRAVEL_YOUTH',
  SeAccident = 'SE_ACCIDENT',
  SeAccidentStudent = 'SE_ACCIDENT_STUDENT',
  SeApartmentBrf = 'SE_APARTMENT_BRF',
  SeApartmentRent = 'SE_APARTMENT_RENT',
  SeApartmentStudentBrf = 'SE_APARTMENT_STUDENT_BRF',
  SeApartmentStudentRent = 'SE_APARTMENT_STUDENT_RENT',
  SeHouse = 'SE_HOUSE'
}

/**
 * A data type returned by certain mutations that is meant to carry user-displayable and localized
 * messages.
 *
 * The errors are usually translated through the `Hedvig-Language` header.
 */
export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String'];
};

export type Welcome = {
  __typename?: 'Welcome';
  illustration: Icon;
  paragraph: Scalars['String'];
  title: Scalars['String'];
};

export type BankSigneringApprovalCreateMutationVariables = Exact<{
  productOfferId: Scalars['UUID'];
}>;


export type BankSigneringApprovalCreateMutation = { __typename?: 'Mutation', bankSigneringApprovalCreate: { __typename?: 'BankSigneringApproval', url: string } };

export type CartEntryAddMutationVariables = Exact<{
  cartId: Scalars['UUID'];
  offerId: Scalars['UUID'];
}>;


export type CartEntryAddMutation = { __typename?: 'Mutation', cartEntriesAdd: { __typename?: 'CartMutationOutput', cart?: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type CartEntryRemoveMutationVariables = Exact<{
  cartId: Scalars['UUID'];
  offerId: Scalars['UUID'];
}>;


export type CartEntryRemoveMutation = { __typename?: 'Mutation', cartEntriesRemove: { __typename?: 'CartMutationOutput', cart?: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type CartFragmentFragment = { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> };

export type RedeemCampaignMutationVariables = Exact<{
  cartId: Scalars['UUID'];
  code: Scalars['String'];
}>;


export type RedeemCampaignMutation = { __typename?: 'Mutation', cartRedeemCampaign: { __typename?: 'CartMutationOutput', cart?: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type UnredeemCampaignMutationVariables = Exact<{
  cartId: Scalars['UUID'];
  campaignId: Scalars['String'];
}>;


export type UnredeemCampaignMutation = { __typename?: 'Mutation', cartUnredeemCampaign: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } };

export type BankSigneringInitMutationVariables = Exact<{
  contractId: Scalars['UUID'];
}>;


export type BankSigneringInitMutation = { __typename?: 'Mutation', contractBankSigneringCancellationInitiate: { __typename?: 'Contract', id: string, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null } };

export type ContractExternalInsuranceCancellationFragment = { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null };

export type CurrentMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMemberQuery = { __typename?: 'Query', currentMember: { __typename?: 'Member', id: string, hasActivePaymentConnection: boolean } };

export type ExternalInsurerUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID'];
  externalInsurerId?: InputMaybe<Scalars['ID']>;
}>;


export type ExternalInsurerUpdateMutation = { __typename?: 'Mutation', priceIntentExternalInsurerUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type ExternalInsurersQueryVariables = Exact<{
  productName: Scalars['String'];
}>;


export type ExternalInsurersQuery = { __typename?: 'Query', product?: { __typename?: 'Product', externalInsurers: Array<{ __typename?: 'ExternalInsurer', id: string, displayName: string }> } | null };

export type InsurelyDataCollectionCreateMutationVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type InsurelyDataCollectionCreateMutation = { __typename?: 'Mutation', insurelyInitiateIframeDataCollection: { __typename?: 'InsurelyInitiateIframeDataCollectionOutput', dataCollectionId: string } };

export type OfferRecommendationFragment = { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, product: { __typename?: 'Product', id: string, displayNameFull: string } }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } };

export type PerilFragment = { __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null };

export type PriceIntentQueryVariables = Exact<{
  priceIntentId: Scalars['UUID'];
}>;


export type PriceIntentQuery = { __typename?: 'Query', priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null } };

export type PriceIntentAvailableBreedsQueryVariables = Exact<{
  animal: PriceIntentAnimal;
}>;


export type PriceIntentAvailableBreedsQuery = { __typename?: 'Query', priceIntentAvailableBreeds: Array<{ __typename?: 'PriceIntentAnimalBreed', id: string, displayName: string, isMixedBreed: boolean }> };

export type CancellationRequestedUpdateMutationVariables = Exact<{
  productOfferIds: Array<Scalars['UUID']> | Scalars['UUID'];
  requested: Scalars['Boolean'];
}>;


export type CancellationRequestedUpdateMutation = { __typename?: 'Mutation', productOffersCancellationRequestedUpdate: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, userError?: { __typename?: 'UserError', message: string } | null } };

export type PriceIntentConfirmMutationVariables = Exact<{
  priceIntentId: Scalars['UUID'];
}>;


export type PriceIntentConfirmMutation = { __typename?: 'Mutation', priceIntentConfirm: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type PriceIntentCreateMutationVariables = Exact<{
  shopSessionId: Scalars['UUID'];
  productName: Scalars['String'];
}>;


export type PriceIntentCreateMutation = { __typename?: 'Mutation', priceIntentCreate: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null } };

export type PriceIntentDataUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID'];
  data: Scalars['PricingFormData'];
  customer: ShopSessionCustomerUpdateInput;
}>;


export type PriceIntentDataUpdateMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null } | null, userError?: { __typename?: 'UserError', message: string } | null }, shopSessionCustomerUpdate: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', authenticationStatus: ShopSessionAuthenticationStatus, email?: string | null, firstName?: string | null, lastName?: string | null, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type PriceIntentFragmentFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null };

export type PriceIntentInsurelyUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID'];
  dataCollectionId: Scalars['String'];
}>;


export type PriceIntentInsurelyUpdateMutation = { __typename?: 'Mutation', priceIntentInsurelyUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type ProductDataQueryVariables = Exact<{
  productName: Scalars['String'];
}>;


export type ProductDataQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, insurelyClientId?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string }, variants: Array<{ __typename?: 'ProductVariant', typeOfContract: string, displayName: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string> }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', type: InsurableLimitType, label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }> } | null };

export type ProductMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductMetadataQuery = { __typename?: 'Query', availableProducts: Array<{ __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }> };

export type ProductOfferFragment = { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null };

export type ProductRecommendationFragment = { __typename?: 'Product', id: string, displayNameFull: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null };

export type ProductRecommendationsQueryVariables = Exact<{
  shopSessionId: Scalars['UUID'];
}>;


export type ProductRecommendationsQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, recommendations: Array<{ __typename?: 'ProductRecommendation', product: { __typename?: 'Product', id: string, displayNameFull: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null }, offer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, product: { __typename?: 'Product', id: string, displayNameFull: string } }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null }> } };

export type ShopSessionQueryVariables = Exact<{
  shopSessionId: Scalars['UUID'];
}>;


export type ShopSessionQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', authenticationStatus: ShopSessionAuthenticationStatus, email?: string | null, firstName?: string | null, lastName?: string | null, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } } };

export type ShopSessionAuthenticateMutationVariables = Exact<{
  shopSessionId: Scalars['UUID'];
}>;


export type ShopSessionAuthenticateMutation = { __typename?: 'Mutation', shopSessionAuthenticate: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', authenticationStatus: ShopSessionAuthenticationStatus, email?: string | null, firstName?: string | null, lastName?: string | null, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } } };

export type ShopSessionCreateMutationVariables = Exact<{
  countryCode: CountryCode;
  attributedTo?: InputMaybe<Scalars['String']>;
  initiatedFrom?: InputMaybe<Scalars['String']>;
}>;


export type ShopSessionCreateMutation = { __typename?: 'Mutation', shopSessionCreate: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', authenticationStatus: ShopSessionAuthenticationStatus, email?: string | null, firstName?: string | null, lastName?: string | null, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } } };

export type ShopSessionCustomerUpdateMutationVariables = Exact<{
  input: ShopSessionCustomerUpdateInput;
}>;


export type ShopSessionCustomerUpdateMutation = { __typename?: 'Mutation', shopSessionCustomerUpdate: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', authenticationStatus: ShopSessionAuthenticationStatus, email?: string | null, firstName?: string | null, lastName?: string | null, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type ShopSessionFragment = { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', authenticationStatus: ShopSessionAuthenticationStatus, email?: string | null, firstName?: string | null, lastName?: string | null, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaigns: Array<{ __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } }>, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }> } };

export type ShopSessionOutcomeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ShopSessionOutcomeQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', outcome?: { __typename?: 'ShopSessionOutcome', id: string, createdContracts: Array<{ __typename?: 'Contract', id: string, variant: { __typename?: 'ProductVariant', displayName: string }, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null }> } | null } };

export type ShopSessionSigningQueryVariables = Exact<{
  shopSessionSigningId: Scalars['UUID'];
}>;


export type ShopSessionSigningQuery = { __typename?: 'Query', shopSessionSigning: { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null } };

export type ShopSessionSigningFragment = { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null };

export type ShopSessionStartSignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID'];
}>;


export type ShopSessionStartSignMutation = { __typename?: 'Mutation', shopSessionStartSign: { __typename?: 'ShopSessionSigningMutationOutput', signing?: { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null } | null, userError?: { __typename?: 'UserError', message: string } | null } };

export type StartDateUpdateMutationVariables = Exact<{
  productOfferIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate: Scalars['Date'];
}>;


export type StartDateUpdateMutation = { __typename?: 'Mutation', productOffersStartDateUpdate: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, price: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null }>, userError?: { __typename?: 'UserError', message: string } | null } };

export const ContractExternalInsuranceCancellationFragmentDoc = gql`
    fragment ContractExternalInsuranceCancellation on ContractExternalInsuranceCancellation {
  id
  status
  externalInsurer {
    id
    displayName
  }
  bankSignering {
    approveByDate
    url
  }
}
    `;
export const OfferRecommendationFragmentDoc = gql`
    fragment OfferRecommendation on ProductOffer {
  id
  startDate
  priceIntentData
  variant {
    typeOfContract
    product {
      id
      displayNameFull
    }
  }
  price {
    amount
    currencyCode
  }
}
    `;
export const PerilFragmentDoc = gql`
    fragment Peril on Peril {
  title
  description
  covered
  exceptions
  colorCode
}
    `;
export const ProductOfferFragmentDoc = gql`
    fragment ProductOffer on ProductOffer {
  id
  variant {
    typeOfContract
    displayName
    product {
      id
      name
      displayNameFull
      pillowImage {
        id
        alt
        src
      }
    }
    perils {
      ...Peril
    }
    documents {
      type
      displayName
      url
    }
  }
  price {
    amount
    currencyCode
  }
  startDate
  cancellation {
    option
    requested
    externalInsurer {
      id
      displayName
    }
    bankSigneringApproveByDate
  }
  priceMatch {
    externalInsurer {
      id
      displayName
    }
    priceReduction {
      amount
      currencyCode
    }
    externalPrice {
      amount
      currencyCode
    }
  }
  priceIntentData
  deductible {
    displayName
    tagline
  }
}
    ${PerilFragmentDoc}`;
export const PriceIntentFragmentFragmentDoc = gql`
    fragment PriceIntentFragment on PriceIntent {
  id
  data
  suggestedData
  offers {
    ...ProductOffer
  }
  externalInsurer {
    id
    displayName
    insurelyId
  }
}
    ${ProductOfferFragmentDoc}`;
export const ProductRecommendationFragmentDoc = gql`
    fragment ProductRecommendation on Product {
  id
  displayNameFull
  displayNameShort
  pageLink
  pillowImage {
    id
    src
    alt
  }
  featuredImage {
    id
    src
    alt
  }
}
    `;
export const CartFragmentFragmentDoc = gql`
    fragment CartFragment on Cart {
  id
  campaignsEnabled
  cost {
    gross {
      amount
      currencyCode
    }
    net {
      amount
      currencyCode
    }
    discount {
      amount
      currencyCode
    }
  }
  redeemedCampaigns {
    id
    code
    discount {
      type
      amount {
        currencyCode
        amount
      }
      percentage
      months
    }
  }
  entries {
    ...ProductOffer
  }
}
    ${ProductOfferFragmentDoc}`;
export const ShopSessionFragmentDoc = gql`
    fragment ShopSession on ShopSession {
  id
  countryCode
  currencyCode
  customer {
    authenticationStatus
    email
    firstName
    lastName
    ssn
  }
  cart {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export const ShopSessionSigningFragmentDoc = gql`
    fragment ShopSessionSigning on ShopSessionSigning {
  id
  status
  completion {
    authorizationCode
  }
}
    `;
export const BankSigneringApprovalCreateDocument = gql`
    mutation BankSigneringApprovalCreate($productOfferId: UUID!) {
  bankSigneringApprovalCreate(productOfferId: $productOfferId) {
    url
  }
}
    `;
export type BankSigneringApprovalCreateMutationFn = Apollo.MutationFunction<BankSigneringApprovalCreateMutation, BankSigneringApprovalCreateMutationVariables>;

/**
 * __useBankSigneringApprovalCreateMutation__
 *
 * To run a mutation, you first call `useBankSigneringApprovalCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankSigneringApprovalCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankSigneringApprovalCreateMutation, { data, loading, error }] = useBankSigneringApprovalCreateMutation({
 *   variables: {
 *      productOfferId: // value for 'productOfferId'
 *   },
 * });
 */
export function useBankSigneringApprovalCreateMutation(baseOptions?: Apollo.MutationHookOptions<BankSigneringApprovalCreateMutation, BankSigneringApprovalCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankSigneringApprovalCreateMutation, BankSigneringApprovalCreateMutationVariables>(BankSigneringApprovalCreateDocument, options);
      }
export type BankSigneringApprovalCreateMutationHookResult = ReturnType<typeof useBankSigneringApprovalCreateMutation>;
export type BankSigneringApprovalCreateMutationResult = Apollo.MutationResult<BankSigneringApprovalCreateMutation>;
export type BankSigneringApprovalCreateMutationOptions = Apollo.BaseMutationOptions<BankSigneringApprovalCreateMutation, BankSigneringApprovalCreateMutationVariables>;
export const CartEntryAddDocument = gql`
    mutation CartEntryAdd($cartId: UUID!, $offerId: UUID!) {
  cartEntriesAdd(input: {cartId: $cartId, offerIds: [$offerId]}) {
    cart {
      ...CartFragment
    }
    userError {
      message
    }
  }
}
    ${CartFragmentFragmentDoc}`;
export type CartEntryAddMutationFn = Apollo.MutationFunction<CartEntryAddMutation, CartEntryAddMutationVariables>;

/**
 * __useCartEntryAddMutation__
 *
 * To run a mutation, you first call `useCartEntryAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryAddMutation, { data, loading, error }] = useCartEntryAddMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCartEntryAddMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryAddMutation, CartEntryAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryAddMutation, CartEntryAddMutationVariables>(CartEntryAddDocument, options);
      }
export type CartEntryAddMutationHookResult = ReturnType<typeof useCartEntryAddMutation>;
export type CartEntryAddMutationResult = Apollo.MutationResult<CartEntryAddMutation>;
export type CartEntryAddMutationOptions = Apollo.BaseMutationOptions<CartEntryAddMutation, CartEntryAddMutationVariables>;
export const CartEntryRemoveDocument = gql`
    mutation CartEntryRemove($cartId: UUID!, $offerId: UUID!) {
  cartEntriesRemove(input: {cartId: $cartId, offerIds: [$offerId]}) {
    cart {
      ...CartFragment
    }
    userError {
      message
    }
  }
}
    ${CartFragmentFragmentDoc}`;
export type CartEntryRemoveMutationFn = Apollo.MutationFunction<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>;

/**
 * __useCartEntryRemoveMutation__
 *
 * To run a mutation, you first call `useCartEntryRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryRemoveMutation, { data, loading, error }] = useCartEntryRemoveMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCartEntryRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>(CartEntryRemoveDocument, options);
      }
export type CartEntryRemoveMutationHookResult = ReturnType<typeof useCartEntryRemoveMutation>;
export type CartEntryRemoveMutationResult = Apollo.MutationResult<CartEntryRemoveMutation>;
export type CartEntryRemoveMutationOptions = Apollo.BaseMutationOptions<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>;
export const RedeemCampaignDocument = gql`
    mutation RedeemCampaign($cartId: UUID!, $code: String!) {
  cartRedeemCampaign(input: {cartId: $cartId, code: $code}) {
    cart {
      ...CartFragment
    }
    userError {
      message
    }
  }
}
    ${CartFragmentFragmentDoc}`;
export type RedeemCampaignMutationFn = Apollo.MutationFunction<RedeemCampaignMutation, RedeemCampaignMutationVariables>;

/**
 * __useRedeemCampaignMutation__
 *
 * To run a mutation, you first call `useRedeemCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemCampaignMutation, { data, loading, error }] = useRedeemCampaignMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RedeemCampaignMutation, RedeemCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemCampaignMutation, RedeemCampaignMutationVariables>(RedeemCampaignDocument, options);
      }
export type RedeemCampaignMutationHookResult = ReturnType<typeof useRedeemCampaignMutation>;
export type RedeemCampaignMutationResult = Apollo.MutationResult<RedeemCampaignMutation>;
export type RedeemCampaignMutationOptions = Apollo.BaseMutationOptions<RedeemCampaignMutation, RedeemCampaignMutationVariables>;
export const UnredeemCampaignDocument = gql`
    mutation UnredeemCampaign($cartId: UUID!, $campaignId: String!) {
  cartUnredeemCampaign(input: {cartId: $cartId, campaignId: $campaignId}) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export type UnredeemCampaignMutationFn = Apollo.MutationFunction<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>;

/**
 * __useUnredeemCampaignMutation__
 *
 * To run a mutation, you first call `useUnredeemCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnredeemCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unredeemCampaignMutation, { data, loading, error }] = useUnredeemCampaignMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUnredeemCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>(UnredeemCampaignDocument, options);
      }
export type UnredeemCampaignMutationHookResult = ReturnType<typeof useUnredeemCampaignMutation>;
export type UnredeemCampaignMutationResult = Apollo.MutationResult<UnredeemCampaignMutation>;
export type UnredeemCampaignMutationOptions = Apollo.BaseMutationOptions<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>;
export const BankSigneringInitDocument = gql`
    mutation BankSigneringInit($contractId: UUID!) {
  contractBankSigneringCancellationInitiate(contractId: $contractId) {
    id
    externalInsuranceCancellation {
      ...ContractExternalInsuranceCancellation
    }
  }
}
    ${ContractExternalInsuranceCancellationFragmentDoc}`;
export type BankSigneringInitMutationFn = Apollo.MutationFunction<BankSigneringInitMutation, BankSigneringInitMutationVariables>;

/**
 * __useBankSigneringInitMutation__
 *
 * To run a mutation, you first call `useBankSigneringInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankSigneringInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankSigneringInitMutation, { data, loading, error }] = useBankSigneringInitMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useBankSigneringInitMutation(baseOptions?: Apollo.MutationHookOptions<BankSigneringInitMutation, BankSigneringInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankSigneringInitMutation, BankSigneringInitMutationVariables>(BankSigneringInitDocument, options);
      }
export type BankSigneringInitMutationHookResult = ReturnType<typeof useBankSigneringInitMutation>;
export type BankSigneringInitMutationResult = Apollo.MutationResult<BankSigneringInitMutation>;
export type BankSigneringInitMutationOptions = Apollo.BaseMutationOptions<BankSigneringInitMutation, BankSigneringInitMutationVariables>;
export const CurrentMemberDocument = gql`
    query CurrentMember {
  currentMember {
    id
    hasActivePaymentConnection
  }
}
    `;

/**
 * __useCurrentMemberQuery__
 *
 * To run a query within a React component, call `useCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentMemberQuery(baseOptions?: Apollo.QueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
      }
export function useCurrentMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
        }
export type CurrentMemberQueryHookResult = ReturnType<typeof useCurrentMemberQuery>;
export type CurrentMemberLazyQueryHookResult = ReturnType<typeof useCurrentMemberLazyQuery>;
export type CurrentMemberQueryResult = Apollo.QueryResult<CurrentMemberQuery, CurrentMemberQueryVariables>;
export const ExternalInsurerUpdateDocument = gql`
    mutation ExternalInsurerUpdate($priceIntentId: UUID!, $externalInsurerId: ID) {
  priceIntentExternalInsurerUpdate(
    priceIntentId: $priceIntentId
    externalInsurerId: $externalInsurerId
  ) {
    priceIntent {
      ...PriceIntentFragment
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentFragmentDoc}`;
export type ExternalInsurerUpdateMutationFn = Apollo.MutationFunction<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>;

/**
 * __useExternalInsurerUpdateMutation__
 *
 * To run a mutation, you first call `useExternalInsurerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalInsurerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalInsurerUpdateMutation, { data, loading, error }] = useExternalInsurerUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      externalInsurerId: // value for 'externalInsurerId'
 *   },
 * });
 */
export function useExternalInsurerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>(ExternalInsurerUpdateDocument, options);
      }
export type ExternalInsurerUpdateMutationHookResult = ReturnType<typeof useExternalInsurerUpdateMutation>;
export type ExternalInsurerUpdateMutationResult = Apollo.MutationResult<ExternalInsurerUpdateMutation>;
export type ExternalInsurerUpdateMutationOptions = Apollo.BaseMutationOptions<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>;
export const ExternalInsurersDocument = gql`
    query ExternalInsurers($productName: String!) {
  product(productName: $productName) {
    externalInsurers {
      id
      displayName
    }
  }
}
    `;

/**
 * __useExternalInsurersQuery__
 *
 * To run a query within a React component, call `useExternalInsurersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalInsurersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalInsurersQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useExternalInsurersQuery(baseOptions: Apollo.QueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
      }
export function useExternalInsurersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
        }
export type ExternalInsurersQueryHookResult = ReturnType<typeof useExternalInsurersQuery>;
export type ExternalInsurersLazyQueryHookResult = ReturnType<typeof useExternalInsurersLazyQuery>;
export type ExternalInsurersQueryResult = Apollo.QueryResult<ExternalInsurersQuery, ExternalInsurersQueryVariables>;
export const InsurelyDataCollectionCreateDocument = gql`
    mutation InsurelyDataCollectionCreate($collectionId: String!) {
  insurelyInitiateIframeDataCollection(input: {collectionId: $collectionId}) {
    dataCollectionId
  }
}
    `;
export type InsurelyDataCollectionCreateMutationFn = Apollo.MutationFunction<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>;

/**
 * __useInsurelyDataCollectionCreateMutation__
 *
 * To run a mutation, you first call `useInsurelyDataCollectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsurelyDataCollectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insurelyDataCollectionCreateMutation, { data, loading, error }] = useInsurelyDataCollectionCreateMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useInsurelyDataCollectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>(InsurelyDataCollectionCreateDocument, options);
      }
export type InsurelyDataCollectionCreateMutationHookResult = ReturnType<typeof useInsurelyDataCollectionCreateMutation>;
export type InsurelyDataCollectionCreateMutationResult = Apollo.MutationResult<InsurelyDataCollectionCreateMutation>;
export type InsurelyDataCollectionCreateMutationOptions = Apollo.BaseMutationOptions<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>;
export const PriceIntentDocument = gql`
    query PriceIntent($priceIntentId: UUID!) {
  priceIntent(id: $priceIntentId) {
    ...PriceIntentFragment
  }
}
    ${PriceIntentFragmentFragmentDoc}`;

/**
 * __usePriceIntentQuery__
 *
 * To run a query within a React component, call `usePriceIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentQuery({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function usePriceIntentQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
      }
export function usePriceIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
        }
export type PriceIntentQueryHookResult = ReturnType<typeof usePriceIntentQuery>;
export type PriceIntentLazyQueryHookResult = ReturnType<typeof usePriceIntentLazyQuery>;
export type PriceIntentQueryResult = Apollo.QueryResult<PriceIntentQuery, PriceIntentQueryVariables>;
export const PriceIntentAvailableBreedsDocument = gql`
    query PriceIntentAvailableBreeds($animal: PriceIntentAnimal!) {
  priceIntentAvailableBreeds(animal: $animal) {
    id
    displayName
    isMixedBreed
  }
}
    `;

/**
 * __usePriceIntentAvailableBreedsQuery__
 *
 * To run a query within a React component, call `usePriceIntentAvailableBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentAvailableBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentAvailableBreedsQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *   },
 * });
 */
export function usePriceIntentAvailableBreedsQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
      }
export function usePriceIntentAvailableBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
        }
export type PriceIntentAvailableBreedsQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsQuery>;
export type PriceIntentAvailableBreedsLazyQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsLazyQuery>;
export type PriceIntentAvailableBreedsQueryResult = Apollo.QueryResult<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>;
export const CancellationRequestedUpdateDocument = gql`
    mutation CancellationRequestedUpdate($productOfferIds: [UUID!]!, $requested: Boolean!) {
  productOffersCancellationRequestedUpdate(
    productOfferIds: $productOfferIds
    requested: $requested
  ) {
    productOffers {
      ...ProductOffer
    }
    userError {
      message
    }
  }
}
    ${ProductOfferFragmentDoc}`;
export type CancellationRequestedUpdateMutationFn = Apollo.MutationFunction<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>;

/**
 * __useCancellationRequestedUpdateMutation__
 *
 * To run a mutation, you first call `useCancellationRequestedUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancellationRequestedUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancellationRequestedUpdateMutation, { data, loading, error }] = useCancellationRequestedUpdateMutation({
 *   variables: {
 *      productOfferIds: // value for 'productOfferIds'
 *      requested: // value for 'requested'
 *   },
 * });
 */
export function useCancellationRequestedUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>(CancellationRequestedUpdateDocument, options);
      }
export type CancellationRequestedUpdateMutationHookResult = ReturnType<typeof useCancellationRequestedUpdateMutation>;
export type CancellationRequestedUpdateMutationResult = Apollo.MutationResult<CancellationRequestedUpdateMutation>;
export type CancellationRequestedUpdateMutationOptions = Apollo.BaseMutationOptions<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>;
export const PriceIntentConfirmDocument = gql`
    mutation PriceIntentConfirm($priceIntentId: UUID!) {
  priceIntentConfirm(priceIntentId: $priceIntentId) {
    priceIntent {
      ...PriceIntentFragment
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentFragmentDoc}`;
export type PriceIntentConfirmMutationFn = Apollo.MutationFunction<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>;

/**
 * __usePriceIntentConfirmMutation__
 *
 * To run a mutation, you first call `usePriceIntentConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentConfirmMutation, { data, loading, error }] = usePriceIntentConfirmMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function usePriceIntentConfirmMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>(PriceIntentConfirmDocument, options);
      }
export type PriceIntentConfirmMutationHookResult = ReturnType<typeof usePriceIntentConfirmMutation>;
export type PriceIntentConfirmMutationResult = Apollo.MutationResult<PriceIntentConfirmMutation>;
export type PriceIntentConfirmMutationOptions = Apollo.BaseMutationOptions<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>;
export const PriceIntentCreateDocument = gql`
    mutation PriceIntentCreate($shopSessionId: UUID!, $productName: String!) {
  priceIntentCreate(
    input: {shopSessionId: $shopSessionId, productName: $productName}
  ) {
    ...PriceIntentFragment
  }
}
    ${PriceIntentFragmentFragmentDoc}`;
export type PriceIntentCreateMutationFn = Apollo.MutationFunction<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>;

/**
 * __usePriceIntentCreateMutation__
 *
 * To run a mutation, you first call `usePriceIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentCreateMutation, { data, loading, error }] = usePriceIntentCreateMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function usePriceIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>(PriceIntentCreateDocument, options);
      }
export type PriceIntentCreateMutationHookResult = ReturnType<typeof usePriceIntentCreateMutation>;
export type PriceIntentCreateMutationResult = Apollo.MutationResult<PriceIntentCreateMutation>;
export type PriceIntentCreateMutationOptions = Apollo.BaseMutationOptions<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>;
export const PriceIntentDataUpdateDocument = gql`
    mutation PriceIntentDataUpdate($priceIntentId: UUID!, $data: PricingFormData!, $customer: ShopSessionCustomerUpdateInput!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      ...PriceIntentFragment
    }
    userError {
      message
    }
  }
  shopSessionCustomerUpdate(input: $customer) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentFragmentDoc}
${ShopSessionFragmentDoc}`;
export type PriceIntentDataUpdateMutationFn = Apollo.MutationFunction<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>;

/**
 * __usePriceIntentDataUpdateMutation__
 *
 * To run a mutation, you first call `usePriceIntentDataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentDataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentDataUpdateMutation, { data, loading, error }] = usePriceIntentDataUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function usePriceIntentDataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>(PriceIntentDataUpdateDocument, options);
      }
export type PriceIntentDataUpdateMutationHookResult = ReturnType<typeof usePriceIntentDataUpdateMutation>;
export type PriceIntentDataUpdateMutationResult = Apollo.MutationResult<PriceIntentDataUpdateMutation>;
export type PriceIntentDataUpdateMutationOptions = Apollo.BaseMutationOptions<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>;
export const PriceIntentInsurelyUpdateDocument = gql`
    mutation PriceIntentInsurelyUpdate($priceIntentId: UUID!, $dataCollectionId: String!) {
  priceIntentInsurelyUpdate(
    priceIntentId: $priceIntentId
    dataCollectionId: $dataCollectionId
  ) {
    priceIntent {
      ...PriceIntentFragment
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentFragmentDoc}`;
export type PriceIntentInsurelyUpdateMutationFn = Apollo.MutationFunction<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>;

/**
 * __usePriceIntentInsurelyUpdateMutation__
 *
 * To run a mutation, you first call `usePriceIntentInsurelyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentInsurelyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentInsurelyUpdateMutation, { data, loading, error }] = usePriceIntentInsurelyUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      dataCollectionId: // value for 'dataCollectionId'
 *   },
 * });
 */
export function usePriceIntentInsurelyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>(PriceIntentInsurelyUpdateDocument, options);
      }
export type PriceIntentInsurelyUpdateMutationHookResult = ReturnType<typeof usePriceIntentInsurelyUpdateMutation>;
export type PriceIntentInsurelyUpdateMutationResult = Apollo.MutationResult<PriceIntentInsurelyUpdateMutation>;
export type PriceIntentInsurelyUpdateMutationOptions = Apollo.BaseMutationOptions<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>;
export const ProductDataDocument = gql`
    query ProductData($productName: String!) {
  product(productName: $productName) {
    id
    name
    displayNameFull
    displayNameShort
    tagline
    pillowImage {
      id
      alt
      src
    }
    insurelyClientId
    variants {
      typeOfContract
      displayName
      perils {
        title
        description
        covered
        exceptions
      }
      insurableLimits {
        type
        label
        limit
        description
      }
      documents {
        type
        displayName
        url
      }
    }
  }
}
    `;

/**
 * __useProductDataQuery__
 *
 * To run a query within a React component, call `useProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDataQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useProductDataQuery(baseOptions: Apollo.QueryHookOptions<ProductDataQuery, ProductDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
      }
export function useProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDataQuery, ProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
        }
export type ProductDataQueryHookResult = ReturnType<typeof useProductDataQuery>;
export type ProductDataLazyQueryHookResult = ReturnType<typeof useProductDataLazyQuery>;
export type ProductDataQueryResult = Apollo.QueryResult<ProductDataQuery, ProductDataQueryVariables>;
export const ProductMetadataDocument = gql`
    query ProductMetadata {
  availableProducts {
    id
    name
    displayNameShort
    pageLink
    pillowImage {
      id
      alt
      src
    }
  }
}
    `;

/**
 * __useProductMetadataQuery__
 *
 * To run a query within a React component, call `useProductMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductMetadataQuery(baseOptions?: Apollo.QueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
      }
export function useProductMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
        }
export type ProductMetadataQueryHookResult = ReturnType<typeof useProductMetadataQuery>;
export type ProductMetadataLazyQueryHookResult = ReturnType<typeof useProductMetadataLazyQuery>;
export type ProductMetadataQueryResult = Apollo.QueryResult<ProductMetadataQuery, ProductMetadataQueryVariables>;
export const ProductRecommendationsDocument = gql`
    query ProductRecommendations($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    recommendations {
      product {
        ...ProductRecommendation
      }
      offer {
        ...OfferRecommendation
      }
    }
  }
}
    ${ProductRecommendationFragmentDoc}
${OfferRecommendationFragmentDoc}`;

/**
 * __useProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRecommendationsQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useProductRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
      }
export function useProductRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
        }
export type ProductRecommendationsQueryHookResult = ReturnType<typeof useProductRecommendationsQuery>;
export type ProductRecommendationsLazyQueryHookResult = ReturnType<typeof useProductRecommendationsLazyQuery>;
export type ProductRecommendationsQueryResult = Apollo.QueryResult<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>;
export const ShopSessionDocument = gql`
    query ShopSession($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;

/**
 * __useShopSessionQuery__
 *
 * To run a query within a React component, call `useShopSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
      }
export function useShopSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
        }
export type ShopSessionQueryHookResult = ReturnType<typeof useShopSessionQuery>;
export type ShopSessionLazyQueryHookResult = ReturnType<typeof useShopSessionLazyQuery>;
export type ShopSessionQueryResult = Apollo.QueryResult<ShopSessionQuery, ShopSessionQueryVariables>;
export const ShopSessionAuthenticateDocument = gql`
    mutation ShopSessionAuthenticate($shopSessionId: UUID!) {
  shopSessionAuthenticate(id: $shopSessionId) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;
export type ShopSessionAuthenticateMutationFn = Apollo.MutationFunction<ShopSessionAuthenticateMutation, ShopSessionAuthenticateMutationVariables>;

/**
 * __useShopSessionAuthenticateMutation__
 *
 * To run a mutation, you first call `useShopSessionAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionAuthenticateMutation, { data, loading, error }] = useShopSessionAuthenticateMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionAuthenticateMutation, ShopSessionAuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionAuthenticateMutation, ShopSessionAuthenticateMutationVariables>(ShopSessionAuthenticateDocument, options);
      }
export type ShopSessionAuthenticateMutationHookResult = ReturnType<typeof useShopSessionAuthenticateMutation>;
export type ShopSessionAuthenticateMutationResult = Apollo.MutationResult<ShopSessionAuthenticateMutation>;
export type ShopSessionAuthenticateMutationOptions = Apollo.BaseMutationOptions<ShopSessionAuthenticateMutation, ShopSessionAuthenticateMutationVariables>;
export const ShopSessionCreateDocument = gql`
    mutation ShopSessionCreate($countryCode: CountryCode!, $attributedTo: String, $initiatedFrom: String) {
  shopSessionCreate(
    input: {countryCode: $countryCode, attributedTo: $attributedTo, initiatedFrom: $initiatedFrom}
  ) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;
export type ShopSessionCreateMutationFn = Apollo.MutationFunction<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>;

/**
 * __useShopSessionCreateMutation__
 *
 * To run a mutation, you first call `useShopSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionCreateMutation, { data, loading, error }] = useShopSessionCreateMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      attributedTo: // value for 'attributedTo'
 *      initiatedFrom: // value for 'initiatedFrom'
 *   },
 * });
 */
export function useShopSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>(ShopSessionCreateDocument, options);
      }
export type ShopSessionCreateMutationHookResult = ReturnType<typeof useShopSessionCreateMutation>;
export type ShopSessionCreateMutationResult = Apollo.MutationResult<ShopSessionCreateMutation>;
export type ShopSessionCreateMutationOptions = Apollo.BaseMutationOptions<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>;
export const ShopSessionCustomerUpdateDocument = gql`
    mutation ShopSessionCustomerUpdate($input: ShopSessionCustomerUpdateInput!) {
  shopSessionCustomerUpdate(input: $input) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type ShopSessionCustomerUpdateMutationFn = Apollo.MutationFunction<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>;

/**
 * __useShopSessionCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useShopSessionCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionCustomerUpdateMutation, { data, loading, error }] = useShopSessionCustomerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShopSessionCustomerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>(ShopSessionCustomerUpdateDocument, options);
      }
export type ShopSessionCustomerUpdateMutationHookResult = ReturnType<typeof useShopSessionCustomerUpdateMutation>;
export type ShopSessionCustomerUpdateMutationResult = Apollo.MutationResult<ShopSessionCustomerUpdateMutation>;
export type ShopSessionCustomerUpdateMutationOptions = Apollo.BaseMutationOptions<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>;
export const ShopSessionOutcomeDocument = gql`
    query ShopSessionOutcome($id: UUID!) {
  shopSession(id: $id) {
    outcome {
      id
      createdContracts {
        id
        variant {
          displayName
        }
        externalInsuranceCancellation {
          ...ContractExternalInsuranceCancellation
        }
      }
    }
  }
}
    ${ContractExternalInsuranceCancellationFragmentDoc}`;

/**
 * __useShopSessionOutcomeQuery__
 *
 * To run a query within a React component, call `useShopSessionOutcomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionOutcomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionOutcomeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShopSessionOutcomeQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
      }
export function useShopSessionOutcomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
        }
export type ShopSessionOutcomeQueryHookResult = ReturnType<typeof useShopSessionOutcomeQuery>;
export type ShopSessionOutcomeLazyQueryHookResult = ReturnType<typeof useShopSessionOutcomeLazyQuery>;
export type ShopSessionOutcomeQueryResult = Apollo.QueryResult<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>;
export const ShopSessionSigningDocument = gql`
    query ShopSessionSigning($shopSessionSigningId: UUID!) {
  shopSessionSigning(id: $shopSessionSigningId) {
    ...ShopSessionSigning
  }
}
    ${ShopSessionSigningFragmentDoc}`;

/**
 * __useShopSessionSigningQuery__
 *
 * To run a query within a React component, call `useShopSessionSigningQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionSigningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionSigningQuery({
 *   variables: {
 *      shopSessionSigningId: // value for 'shopSessionSigningId'
 *   },
 * });
 */
export function useShopSessionSigningQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
      }
export function useShopSessionSigningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
        }
export type ShopSessionSigningQueryHookResult = ReturnType<typeof useShopSessionSigningQuery>;
export type ShopSessionSigningLazyQueryHookResult = ReturnType<typeof useShopSessionSigningLazyQuery>;
export type ShopSessionSigningQueryResult = Apollo.QueryResult<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>;
export const ShopSessionStartSignDocument = gql`
    mutation ShopSessionStartSign($shopSessionId: UUID!) {
  shopSessionStartSign(shopSessionId: $shopSessionId) {
    signing {
      ...ShopSessionSigning
    }
    userError {
      message
    }
  }
}
    ${ShopSessionSigningFragmentDoc}`;
export type ShopSessionStartSignMutationFn = Apollo.MutationFunction<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>;

/**
 * __useShopSessionStartSignMutation__
 *
 * To run a mutation, you first call `useShopSessionStartSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionStartSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionStartSignMutation, { data, loading, error }] = useShopSessionStartSignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionStartSignMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>(ShopSessionStartSignDocument, options);
      }
export type ShopSessionStartSignMutationHookResult = ReturnType<typeof useShopSessionStartSignMutation>;
export type ShopSessionStartSignMutationResult = Apollo.MutationResult<ShopSessionStartSignMutation>;
export type ShopSessionStartSignMutationOptions = Apollo.BaseMutationOptions<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>;
export const StartDateUpdateDocument = gql`
    mutation StartDateUpdate($productOfferIds: [UUID!]!, $startDate: Date!) {
  productOffersStartDateUpdate(
    productOfferIds: $productOfferIds
    startDate: $startDate
  ) {
    productOffers {
      ...ProductOffer
    }
    userError {
      message
    }
  }
}
    ${ProductOfferFragmentDoc}`;
export type StartDateUpdateMutationFn = Apollo.MutationFunction<StartDateUpdateMutation, StartDateUpdateMutationVariables>;

/**
 * __useStartDateUpdateMutation__
 *
 * To run a mutation, you first call `useStartDateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDateUpdateMutation, { data, loading, error }] = useStartDateUpdateMutation({
 *   variables: {
 *      productOfferIds: // value for 'productOfferIds'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useStartDateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StartDateUpdateMutation, StartDateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDateUpdateMutation, StartDateUpdateMutationVariables>(StartDateUpdateDocument, options);
      }
export type StartDateUpdateMutationHookResult = ReturnType<typeof useStartDateUpdateMutation>;
export type StartDateUpdateMutationResult = Apollo.MutationResult<StartDateUpdateMutation>;
export type StartDateUpdateMutationOptions = Apollo.BaseMutationOptions<StartDateUpdateMutation, StartDateUpdateMutationVariables>;